import React, { useState } from 'react';
import { Box, Button, Grid, CircularProgress, Alert } from '@mui/material';
import FormInput from '../inputs/FormInput';
import { useTranslation } from 'react-i18next';

const FormChangePassword = ({ onSave, isSaving }) => {
    const { i18n } = useTranslation();
    const isArabic = (i18n.language || 'en').startsWith('ar');

    const [formData, setFormData] = useState({
        current_password: '',
        password: '',
        password_confirmation: '',
    });
    const [error, setError] = useState('');

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
        setError('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        if (formData.password !== formData.password_confirmation) {
            setError(isArabic ? 'كلمة المرور الجديدة غير متطابقة' : 'New passwords do not match');
            return;
        }
        onSave(formData);
        // Clear sensitive fields after submit
        setFormData({
            current_password: '',
            password: '',
            password_confirmation: '',
        });
    };

    return (
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 2 }}>
            {error && <Alert severity="error" sx={{ mb: 3 }}>{error}</Alert>}
            
            <Grid container spacing={3}>
                <Grid item xs={12}>
                    <FormInput
                        label={isArabic ? 'كلمة المرور الحالية' : 'Current Password'}
                        name="current_password"
                        type="password"
                        value={formData.current_password}
                        onChange={handleInputChange}
                        required
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormInput
                        label={isArabic ? 'كلمة المرور الجديدة' : 'New Password'}
                        name="password"
                        type="password"
                        value={formData.password}
                        onChange={handleInputChange}
                        required
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <FormInput
                        label={isArabic ? 'تأكيد كلمة المرور الجديدة' : 'Confirm New Password'}
                        name="password_confirmation"
                        type="password"
                        value={formData.password_confirmation}
                        onChange={handleInputChange}
                        required
                        fullWidth
                    />
                </Grid>
                <Grid item xs={12} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <Button
                        type="submit"
                        variant="contained"
                        color="secondary"
                        disabled={isSaving}
                        sx={{ px: 4, py: 1, borderRadius: 2 }}
                    >
                        {isSaving ? <CircularProgress size={24} color="inherit" /> : (isArabic ? 'تحديث كلمة المرور' : 'Update Password')}
                    </Button>
                </Grid>
            </Grid>
        </Box>
    );
};

export default FormChangePassword;
